import { VersionT } from './../../models/models';
import getCorrectFileType from './getCorrectFileType';

const correctVersionFileType = (version: VersionT) => {
    return ({ ...version, FileType: getCorrectFileType(version.FileType) });
};

export default correctVersionFileType;